import { aboutData } from '@/mocks/about';

export default function BrandIntro() {
  return (
    <section className="mb-14">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-center">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-3">
            {aboutData.brandIntro}
          </p>
          <div className="bg-background-100/80 rounded-lg p-5 mb-4">
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-1.5">我们的使命</h4>
            <p className="text-sm text-foreground-600">{aboutData.mission}</p>
          </div>
          <div className="bg-background-100/80 rounded-lg p-5">
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-1.5">我们的愿景</h4>
            <p className="text-sm text-foreground-600">{aboutData.vision}</p>
          </div>
        </div>
        <div className="relative aspect-[4/3] rounded-lg overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20creative%20team%20working%20in%20a%20bright%20open%20office%20space%20with%20warm%20coral%20accent%20furniture%2C%20collaborative%20atmosphere%2C%20natural%20light%2C%20professional%20yet%20friendly%20environment%2C%20clean%20minimalist%20design%2C%20editorial%20photography&width=800&height=600&seq=about-brand-intro&orientation=landscape"
            alt="最新发布页团队"
            className="w-full h-full object-cover"
            title="最新发布页团队"
          />
        </div>
      </div>
    </section>
  );
}